import { SharedCallsData } from "@sms/shared/calls/calls.interface";
import { EmptyAction, PayloadAction, createAction } from "typesafe-actions";

export const initCallsList: (data: SharedCallsData[]) => PayloadAction<"call/updateList", SharedCallsData[]> =
  createAction("call/updateList")<SharedCallsData[]>();

export const createCall: (data: SharedCallsData) => PayloadAction<"call/create", SharedCallsData> =
  createAction("call/create")<SharedCallsData>();

export const updateCall: (data: SharedCallsData) => PayloadAction<"call/update", SharedCallsData> =
  createAction("call/update")<SharedCallsData>();

export const handleConnectSocketCalls: () => EmptyAction<"call/handleConnectSocket"> =
  createAction("call/handleConnectSocket")();
